import { render, staticRenderFns } from "./shareList.vue?vue&type=template&id=62d76968&scoped=true&"
import script from "./shareList.vue?vue&type=script&lang=js&"
export * from "./shareList.vue?vue&type=script&lang=js&"
import style0 from "./shareList.vue?vue&type=style&index=0&id=62d76968&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d76968",
  null
  
)

export default component.exports